import type { ZodSchema } from 'zod'
import { z } from 'zod'
import { storage } from './storage'

export const QC_SESSION_KEYS = {
  qcChallengeData: 'qcChallengeData',
  qcCfd: 'qcCfd',
  qcFutures: 'qcFutures',
  qcAddons: 'qcAddons',
  qcPersonal: 'qcPersonal',
}

export const AnyObjectSchema = z.record(z.any())

const setQuickCheckoutSession = (data: object, key: string) => {
  storage.sessionStorage.setItem(key, data)
}

const getQuickCheckoutSession = (schema: ZodSchema, key: string) => {
  const data = storage.sessionStorage.getItem(key)
  if (data === null) return data

  const parsed = schema.safeParse(data.value)
  if (parsed.success) {
    return parsed.data
  } else {
    return null
  }
}

const saveCFDData = (data: object) => setQuickCheckoutSession(data, QC_SESSION_KEYS.qcCfd)
const saveFuturesData = (data: object) => setQuickCheckoutSession(data, QC_SESSION_KEYS.qcFutures)
const saveFuturesAddons = (data: object) => setQuickCheckoutSession(data, QC_SESSION_KEYS.qcAddons)
const saveChallengeData = (data: object) => setQuickCheckoutSession(data, QC_SESSION_KEYS.qcChallengeData)

const getCFDData = (schema: ZodSchema) => getQuickCheckoutSession(schema, QC_SESSION_KEYS.qcCfd)
const getFuturesData = (schema: ZodSchema) => getQuickCheckoutSession(schema, QC_SESSION_KEYS.qcFutures)
const getFuturesAddons = (schema: ZodSchema) => getQuickCheckoutSession(schema, QC_SESSION_KEYS.qcAddons)
const getChallengeData = (schema?: ZodSchema) =>
  getQuickCheckoutSession(schema || AnyObjectSchema, QC_SESSION_KEYS.qcChallengeData)
const clearAddonsData = () => storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcAddons)
const clearFuturesData = () => storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcFutures)

const clearAllCheckoutData = () => {
  storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcCfd)
  storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcFutures)
  storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcAddons)
  storage.sessionStorage.removeItem(QC_SESSION_KEYS.qcChallengeData)
}

// MAYBE NEW API TO NOT TO BIND FNS TO SPECIFIC ASSET TYPES?
const AddonsSchema = z.object({
  addonCodes: z.array(z.string()),
  platform: z.number().optional(),
})
type AddonSchemaType = z.infer<typeof AddonsSchema>
const addons = {
  save: (data: AddonSchemaType) => setQuickCheckoutSession(AddonsSchema.parse(data), 'addons'),
  restore: (): AddonSchemaType | null => getQuickCheckoutSession(AddonsSchema, 'addons'),
}
// --------

export const QCStorage = {
  saveCFDData,
  saveFuturesData,
  saveFuturesAddons,
  saveChallengeData,

  clearFuturesData,
  clearAddonsData,
  clearAllCheckoutData, //clears all the relevant saved data

  getCFDData,
  getFuturesAddons,
  getFuturesData,
  getChallengeData,

  // NEW API
  addons,
}
